import React from 'react';


function detectmob() {
    if( navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
    ){
        return true;
    }
    else {
        return false;
    }
}

class Filter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            search_string: ''
        };
    }



    changeSearchHandler(event) {
        this.setState({search_string: event.target.value});
    }



    __submitHandler(event) {
        // if(event.keyCode == 13) {
        //     this.props.onSearch({
        //         search: this.state.search_string
        //     });
        // }
    }

    __submitHandlerForm(event) {
        event.preventDefault();
        this.props.onSearch({
            search: this.state.search_string
        });
    }



    render() {
        return (
            <div className="m2filter">
                <form method="POST" onSubmit={this.__submitHandlerForm.bind(this)}>
                    <div className="m2filter__row search__row">
                        <div className="m2filter__search">
                            <label htmlFor="search_input">Поиск </label>
                            <input onKeyDown={this.__submitHandler.bind(this)} id="search_input" type="text" name="search" value={this.state.search_string} onChange={this.changeSearchHandler.bind(this)} />
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}


export default Filter;


// WEBPACK FOOTER //
// ./src/components/FilterBookmark.js